/**
 * Main Application JavaScript
 * This file imports all modules and initializes them
 */

// Import block scripts
import './blocks/faq.js';
import './file-upload.js';
import './reveal-animation.js';

document.addEventListener('DOMContentLoaded', function() {
    console.log('Flexiflotte theme loaded');
});